import { required } from 'vuelidate/lib/validators'
import { timeValidator } from '@/utils/validations/validations'
const requiredMsg = 'Обязательное поле'

export default ({ endDateRequired }) => {
  return {
    name: {
      required: {
        validator: required,
        requiredMsg
      }
    },
    startDate: {
      required: {
        validator: required,
        requiredMsg
      }
    },
    endDate: (() => {
      if (!endDateRequired) {
        return false
      }
      return {
        required: {
          validator: required,
          requiredMsg
        }
      }
    })(),
    scheduleTimes: {
      $each: {
        startTime: {
          validator: { required, timeValidator }
        },
        endTime: {
          validator: { required, timeValidator }
        }
      }
    }

  }
}
